// extracted by mini-css-extract-plugin
export var container = "_8t-0";
export var icon = "_8t-1";
export var text = "_8t-2";